import { Modal } from "react-bootstrap";
import Button from "../../../../../components/common/Button";

interface AuthoriseErrorModalProps {
  showValidationModal: boolean;
  onHide: () => void;
  error: string | string[]; // Accepts both string and array of strings
}

export const ValidationErrorModal: React.FC<AuthoriseErrorModalProps> = ({
  showValidationModal,
  onHide,
  error,
}) => {
  const formatErrors = () => {
    if (!error) return ["No errors found."];

    if (Array.isArray(error)) {
      return error; // Already an array
    }

    if (typeof error === "string") {
      return error.split("\n"); // Split if it's a newline-separated string
    }

    return ["Unexpected error format"];
  };

  return (
    <Modal show={showValidationModal} onHide={onHide}>
      <Modal.Header closeButton style={{ backgroundColor: "#EA4335" }}>
        <Modal.Title>Validation Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>
          {formatErrors().map((err, index) => (
            <li key={index}>{err}</li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} label="Close" />
      </Modal.Footer>
    </Modal>
  );
};
